import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-amz-login',
  templateUrl: './amz-login.component.html',
  styleUrls: ['./amz-login.component.css']
})
export class AmzLoginComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
